<body class="h-screen flex justify-center items-center">
<div class="text-center">
  <img src="../../../../assets/images/branding/YSC-logo.png" alt="Logo" class="mb-4 mx-auto">
  <p class="text-h6 m-6">Forgot Password?</p>
  <p class="text-body2 text-neutral-500">Please enter your email and submit. We will send you the reset password link
    to
    entered email</p>
  <form [formGroup]="forgotPasswordForm" class="space-y-4 text-start">
    <div class="flex flex-col gap-2 py-2">
      <app-text-input formControlName="email" [label]="'Email'"
                      placeholder="Ex: john.bravo@company.com" class="w-full" [fullWidth]="true"></app-text-input>
    </div>
    <div class="py-4">
      <app-button [fullWidth]="true" type="submit" (click)="onForgotPasswordClicked()"
                  [loading]="forgotPasswordState.loading()">Submit
      </app-button>
    </div>
    <div class="flex justify-center items-center py-1 gap-2">
      <p class="text-body2">Already have an account?</p>
      <a class="cursor-pointer text-info-500" (click)="onLoginClicked()">Login</a>
    </div>
  </form>
</div>
</body>
